import { render, staticRenderFns } from "./app-download-banner.vue?vue&type=template&id=42facc8a&scoped=true&"
import script from "./app-download-banner.vue?vue&type=script&lang=js&"
export * from "./app-download-banner.vue?vue&type=script&lang=js&"
import style0 from "./app-download-banner.vue?vue&type=style&index=0&id=42facc8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42facc8a",
  null
  
)

export default component.exports